'use strict';

var adyenPaymentMethods = {
    CREDIT_CARD: {
        name: 'Credit card',
        type: 'scheme',
        sortingMethod: 'AdyenComponent',
        templateId: 'AdyenComponent',
    },
    MB_WAY: {
        name: 'MB WAY',
        type: 'mbway',
        sortingMethod: 'AdyenMbWay',
        templateId: 'AdyenComponent__mbway',
    },
    GOOGLE_PAY: {
        name: 'Google Pay',
        type: 'paywithgoogle',
        sortingMethod: 'AdyenGooglePay',
        templateId: 'AdyenComponent__paywithgoogle',
    },
    APPLE_PAY: {
        name: 'Apple Pay',
        type: 'applepay',
        sortingMethod: 'AdyenApplePay',
        templateId: 'AdyenComponent__applepay',
    },
    P_24: {
        name: 'Przelewy24',
        type: 'onlineBanking_PL',
        sortingMethod: 'AdyenP24',
        templateId: 'AdyenComponent__onlineBanking_PL',
    },
    IDEAL: {
        name: 'iDEAL',
        type: 'ideal',
        sortingMethod: 'AdyenIdeal',
        templateId: 'AdyenComponent__ideal',
    },
    SOFORT: {
        name: 'Sofort',
        type: 'directEbanking',
        sortingMethod: 'AdyenSofort',
        templateId: 'AdyenComponent__directEbanking',
    },
};

/**
 * Enum of the Adyen payments method names of the payment processor with ID 'Adyen_Component'
 * @readonly
 * @enum {string}
 */
var AdyenPaymentMethodNames = {
    CREDIT_CARD: 'Credit card',
    MB_WAY: 'MB WAY',
    GOOGLE_PAY: 'Google Pay',
    APPLE_PAY: 'Apple Pay',
    P_24: 'Przelewy24',
    IDEAL: 'iDEAL',
    SOFORT: 'Sofort',
};

/**
 * Adyen payments method name of the payment processor with ID 'Adyen_Component'
 * @typedef {('Credit card' | 'MB WAY' | 'Google Pay' | 'Apple Pay' | 'Online Banking PL' | 'iDEAL' | 'Sofort')} AdyenPaymentMethodName
 */

/** @type {AdyenPaymentMethodName[]} */
var adyenPaymentMethodNames = [];
var adyenPaymentMethodTypes = [];
var adyenPaymentMethodSortingMethods = [];
var adyenTemplateIds = [];

Object.keys(adyenPaymentMethods).forEach(function (paymentMethod) {
    adyenPaymentMethodNames.push(adyenPaymentMethods[paymentMethod].name);
    adyenPaymentMethodTypes.push(adyenPaymentMethods[paymentMethod].type);
    adyenPaymentMethodSortingMethods.push(
        adyenPaymentMethods[paymentMethod].sortingMethod
    );
    adyenTemplateIds[adyenPaymentMethods[paymentMethod].sortingMethod] =
        adyenPaymentMethods[paymentMethod].templateId;
});

var adyenAltPaymentMethods = adyenPaymentMethodNames.filter(function (name) {
    return name !== adyenPaymentMethods.CREDIT_CARD.name;
});

module.exports = {
    AdyenPaymentMethodNames: AdyenPaymentMethodNames,
    adyenPaymentMethods: adyenPaymentMethods,
    adyenPaymentMethodNames: adyenPaymentMethodNames,
    adyenPaymentMethodTypes: adyenPaymentMethodTypes,
    adyenAltPaymentMethods: adyenAltPaymentMethods,
    adyenPaymentMethodSortingMethods: adyenPaymentMethodSortingMethods,
    adyenTemplateIds: adyenTemplateIds,
};
